var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InspectionReport',{attrs:{"resource":_vm.report,"categories":_vm.categories}})
}
var staticRenderFns = []

export { render, staticRenderFns }